<template>
  <Teleport to="body">
    <div class="tg-pardon" data-testid="thanksgiving-pardon" @click.self="emit('close')">
      <div class="tg-pardon__card" role="dialog" aria-modal="true" aria-labelledby="tg-pardon-title">
        <button type="button" class="tg-pardon__close" aria-label="Close" @click="emit('close')">×</button>
        <p class="tg-pardon__kicker">Official proclamation</p>
        <h3 id="tg-pardon-title" class="tg-pardon__title">Turkey Pardon</h3>
        <p class="tg-pardon__body">
          By the authority vested in Order Protection, this turkey is hereby and forever pardoned. It shall be spared
          the table and live out its days dancing in the sidebar.
        </p>
        <p class="tg-pardon__date">Given this Thanksgiving Day, {{ year }}</p>
        <div class="tg-pardon__footer">
          <div class="tg-pardon__signature">
            <span class="tg-pardon__script">Order Protection</span>
            <span class="tg-pardon__line">Protector of orders, pardoner of turkeys</span>
          </div>
          <svg class="tg-pardon__seal" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" fill="#5b1fd3" />
            <circle cx="32" cy="32" r="26" fill="none" stroke="#fbbf24" stroke-width="2" stroke-dasharray="3 3" />
            <g transform="translate(13.6 12.6) scale(2.4)" fill="#ffffff">
              <path
                d="M7.68626 8.68484L6.35563 7.67335L5.88281 8.25907L7.75212 9.70497L11.3857 5.19165L10.4753 5.125L7.68626 8.68484Z"
              />
              <path
                d="M10.3804 7.56712C9.95309 9.03497 9.04745 10.2229 7.63606 11.1615C6.71159 10.6544 5.96107 9.88098 5.48212 8.94166C5.04616 8.09326 4.78583 7.04883 4.70585 5.82876C5.71725 5.69101 6.71075 5.44415 7.66899 5.09248C8.17396 5.28801 8.69033 5.45272 9.21525 5.58568L9.70845 4.9584C9.01261 4.80151 8.33117 4.58643 7.67134 4.31543C6.55086 4.76786 5.30569 5.05327 3.95703 5.19206C4.00016 8.29085 5.02812 10.7051 7.67134 11.9997C9.8049 10.7051 11.0924 8.86795 11.3433 6.3643L10.3804 7.56712Z"
              />
            </g>
          </svg>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
const emit = defineEmits<{ close: [] }>();

const year = new Date().getFullYear();

function onKeydown(event: KeyboardEvent) {
  if (event.key === 'Escape') emit('close');
}

onMounted(() => window.addEventListener('keydown', onKeydown));
onBeforeUnmount(() => window.removeEventListener('keydown', onKeydown));
</script>
